jQuery(document).ready(function($) {
  $(".header__animated-logo").delay(500).animate({
    width: "120px"
  }, {
    duration: 1500
  });
  setTimeout(function() {
    $(".header__animated-logo-wrapper").css("margin-top", "-58px");
  }, 1000); // 1 second (image delay) + 500ms delay
  setTimeout(function() {
    $(".header__animated-logo-parent").css("width", "500px");
  }, 1500); // 1 second (image delay) + 500ms delay
});